import {
  isAfter as isAfterFns,
  isBefore as isBeforeFns,
  isSameDay as isSameDayFns,
  isToday as isTodayFns,
  isTomorrow as isTomorrowFns,
  isValid as isValidFns,
  isYesterday as isYesterdayFns,
  max as maxFns,
  min as minFns,
} from 'date-fns';

/**
 * @param {Date | number} date1
 * @param {Date | number} date2
 * @returns {boolean}
 */
const isSameDay = (date1: Date | number, date2: Date | number) => {
  return isSameDayFns(date1, date2);
};

/**
 * @param {Date | number} date
 * @returns {boolean}
 */
const isToday = (date: Date | number) => {
  return isTodayFns(date);
};

/**
 * @param {Date | number} date
 * @returns {boolean}
 */
const isTomorrow = (date: Date | number) => {
  return isTomorrowFns(date);
};

/**
 * @param {Date | number} date
 * @returns {boolean}
 */
const isYesterday = (date: Date | number) => {
  return isYesterdayFns(date);
};

/**
 * @param {Date | number} date1
 * @param {Date | number} date2
 * @returns {boolean}
 */
const isAfter = (date1: Date | number, date2: Date | number) => {
  return isAfterFns(date1, date2);
};

/**
 * @param {Date | number} date1
 * @param {Date | number} date2
 * @returns {boolean}
 */
const isBefore = (date1: Date | number, date2: Date | number) => {
  return isBeforeFns(date1, date2);
};

/**
 * @param {Date | number} date
 * @param {Date | number} startDate
 * @param {Date | number} endDate
 * @returns {boolean}
 */
const isBetween = (date: Date | number, startDate: Date | number, endDate: Date | number) => {
  return isAfter(date, startDate) && isBefore(date, endDate);
};

/**
 * @param {Date | number} date
 * @returns {boolean}
 */
const isValid = (date: unknown) => {
  return isValidFns(date);
};

/**
 * @param {Date[]} dates
 * @returns {Date}
 */
const min = (dates: Date[]) => {
  return minFns(dates);
};

/**
 * @param {Date[]} dates
 * @returns {Date}
 */
const max = (dates: Date[]) => {
  return maxFns(dates);
};

export { isSameDay, isToday, isTomorrow, isYesterday, isAfter, isBefore, isBetween, isValid, min, max };
